import React from 'react';
import { Box, Typography } from '@mui/material';
import { HwtButton } from 'components/@common/Buttons/HwtButton';
import { translate } from 'translations/translator';
import { remCalc } from 'util/style-util';
import { getWorkbookTourModalCSS } from '../../../../util/workbook-util';

const t = key => translate('tour', key);

const WorkbookTourModal: React.FC<{
  step: { text: string; position: Record<string, unknown> };
  handleNextStep: () => void;
}> = ({ step, handleNextStep }) => {
  const { text, position } = step;
  return (
    <Box sx={{ ...styles.container, ...getWorkbookTourModalCSS(position) }}>
      {text && <Box component="span" dangerouslySetInnerHTML={{ __html: text }} />}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        <Box
          sx={{
            marginLeft: 'auto'
          }}
        >
          <HwtButton
            style={styles.button}
            variant={'contained'}
            onClick={handleNextStep}
            aria-label={t('gotIt')}
          >
            <Typography variant="body2">{t('gotIt')}</Typography>
          </HwtButton>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    fontWeight: '300',
    boxSizing: 'border-box',
    width: 'max-content',
    maxWidth: remCalc(600),
    borderRadius: remCalc(16),
    backgroundColor: 'white',
    padding: '10px 25px',
    display: 'flex',
    flexDirection: 'column'
  },
  button: {
    marginBottom: 0,
    marginTop: remCalc(30)
  }
};

export default WorkbookTourModal;
